export default __webpack_public_path__ + "static/media/whitepaperten.0ceb190a.png";